export const LOCAL_STORAGE_KEY = {
  username: 'user_name',
  fullName: 'full_name',
  userSession: 'user_session',
  companyId: 'company_id',
  userType: 'user_type',
  userId: 'user_id',
  cacheLogs: 'cache_logs',
  roleList: 'role_list',
  closeWebview: 'close_webview',
  openUrl: 'open_url',
  isLocation: 'is_location',
  pdfUrl: 'pdfUrl',
};

export const TRIGGER_SESSION_KEY = {
  setToken: 'set_token',
  getSessionStorage: 'get_session_storage',
  sessionStorage: 'session_storage',
  removeToken: 'remove_token',
  isActive: 'is_active',
};

export const SESSION_STORAGE_KEY = {
  sessionLogin: 'session_login',
};

export const LocalStorageKey = {
  COMPANY_ID: 'company_id',
  CULTURE: 'culture',
  FULL_NAME: 'full_name',
  MENU: 'menu',
  ORGANIZATION_ID: 'organization_id',
  PERMISSION: 'permission',
  STAFF_ID: 'staff_id',
  ORGANIZATION_CODE: 'organization_code',
  ORGANIZATION_ID_LOGIN: 'organization_id_login',
  COMPANY_LIST: 'company_list',
  DAI_LIST: 'dai_list',
  RELATIVE_ID: 'relative_id',
  DAI_CD: 'daicd',
  PUBLIC_DATE: 'public_date',
  COMPANY_CODE: 'company_code',
  OBJECTCD: 'objectcd',
  DAI_SELECT: 'dai_select',
  RELATIVE_SELECT: 'relative_select',
  CORP_PREFIX: 'corp_prefix',
  AVARTAR_USER: 'avarter_user',
  MESSAGE_LIST: 'message_list',
  PER_ACCOUNT: 'per_account',
  IS_SELECT_DAI: 'is_select_dai',
  DAI_RELATIVE_LIST: 'dai_relative_list',
  PUBLIC_DATE_LIST: 'public_date_list',
  PARTICIPANT_INFO: 'participant_info',
  USER_TYPE: 'user_type',
  DISPLAY_HEADER: 'display_header',
  MST_MESSAGE: 'mst_message',
  ROLE_LIST: 'role_list',
  USER_ID: 'user_id',
  SELECTED_ROLE_ID: 'selected_role_id',
  USER_SESSION: 'user_session',
  CACHE_LOGS: 'cache_logs',
  DAI_RELATIVE_SELECTED: 'dai_relative_selected',
  DAI_AFTER_EDIT: 'dai_after_edit',
  DAI_AFTER_ADD: 'dai_after_add',
  DAI_AFTER_DELETE: 'dai_after_delete',
  HANDLE_FIRST_MENU: 'handle_first_menu',
  INFO_SENT_ACCESS_KEY: 'info_sent_access_key',
  LOGIN_BY_DAI_RELATIVE_CODE: 'login_by_dai_relative_code',
  STATUS_TUTORIAL: 'status_tutorial',
  INFO_SENT_LINKED: 'info_sent_linked',
  CURRENT_SCREEN: 'current_screen',
  SKYWAY_TOKEN: 'skyway_token',
  CUSTID: 'custid',
  CARECONNE_SCHEMA_ID: 'careconne_schema_id',
  LIST_OFFICES: 'list_offices',
  STF_CD: 'stfCd',
  SKIP_FILTER: 'skip_filter',
};
